// extracted by mini-css-extract-plugin
export default {"errorText":"errorText_errorText__W+dch","text-slide-top":"errorText_text-slide-top__dgPuE"};